// extracted by mini-css-extract-plugin
module.exports = {"innerCard":"DisplayController_innerCard__Qozz_","button":"DisplayController_button__22mjy"};